import { render } from "./ValidationList.vue?vue&type=template&id=494cdb7d"
import script from "./ValidationList.vue?vue&type=script&lang=js"
export * from "./ValidationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__